import db from './db';
import {store} from './store';
import {ADD_CACHE, DELETE_CACHE} from './constants/actionTypes';

function addCache(tableId, obj) {
  return {
      type: ADD_CACHE,
      tableId,
      obj
  }
}
function deleteCache(tableId, dataId) {
  return {
      type: DELETE_CACHE,
      tableId,
      dataId
  }
}

const cache = {

  async getRecordList(tableId) {
    let listRecords = await db.getAll(tableId);
    return listRecords;
  },
  
  async saveRecordList(tableId, records) {
    await db.setAll(records, tableId);
  },
  
  async getRecord(tableId, dataId) {
    let record = await db.get(dataId, tableId);
    store.dispatch(addCache(tableId, record));
    return record;
  },
  
  async saveRecord(tableId, value) {
    await db.set(value, tableId);
    store.dispatch(addCache(tableId, value));
  },
  
  async deleteRecord(tableId, dataId) {
    await db.delete(dataId, tableId);
    store.dispatch(deleteCache(tableId, dataId));
  },
};

export default cache;
